(function () {
  'use strict';

  var STORAGE_KEY = 'polly_shipping_zip';

  document.addEventListener('input', function (event) {
    var input = event.target && event.target.closest
      ? event.target.closest('[data-polly-shipping-zip]')
      : null;
    if (!input) return;

    var zip = String(input.value || '').replace(/\D/g, '');
    if (zip.length !== 0) return;

    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }, true);
})();